import { Helmet } from "react-helmet-async";

const SITE = "Moneyssance";
const SITE_URL = "https://moneyssance.com";

/**
 * Per-page SEO helper — sets a unique <title> and <meta description>
 * plus canonical + Open Graph tags. `noindex` flag hides sensitive pages
 * (admin, login) from search engines.
 */
export default function Seo({ title, description, path = "", noindex = false }) {
  const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Miscellaneous thoughts on money and related fields`;
  const desc = description ||
    "A slow financial hub — essays on money, financial tools built and used daily, and thoughts on the fields around them.";
  const url = SITE_URL + path;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
}
